import { useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, 
    MyFormData,
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function PaymentMethodForm({
    closeIt, 
    history, 
    keyword,
    types = [],
    onSuccess
}){
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    //--------------------------------------------------------------------------------------------
    const [selectedType, setSelectedType] = useState("");
    const [customType, setCustomType] = useState("");
    const [last4, setLast4] = useState("");
    //--------------------------------------------------------------------------------------------
    const handleSubmit = async e => {
        e.preventDefault();
        
        // Validation
        const finalType = selectedType === "NEW_TYPE" ? customType.trim() : selectedType;
        
        if(!finalType){
            window.alert("Please select or enter a card type.");
            return;
        }
        
        if(last4 && last4.length !== 4){
            window.alert("Last 4 digits must be exactly 4 characters.");
            return;
        }
        
        if(last4 && !/^\d{4}$/.test(last4)){
            window.alert("Last 4 digits must be numeric.");
            return;
        }
        
        const formData = new MyFormData();
        formData.append("type", finalType);
        formData.append("last4", last4);
        
        //--------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("paymentMethods/createPaymentMethod.php", formData);
        setShowLoader(false);
        if(!res) return;
        //--------------------------------------------------------
        
        // Call success callback to refresh the list
        if(onSuccess){
            onSuccess(res.data);
        }
        
        // Close the modal
        if(history){
            history.goBack();
        } else if(closeIt){
            closeIt();
        }
    }
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {history ? () => {history.goBack()} : closeIt}
            title = {keyword}
            width = {"40rem"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div className = "pl-3 mb-3 pr-3">
                <div className = "d-flex align-items-center mt-2">
                    <label htmlFor = "type" className = "font-weight-bold mb-0">Card Type:</label>
                    <select
                        id = "type"
                        className = "form-control flex-grow-1 ml-3"
                        value = {selectedType}
                        onChange = {e => {
                            setSelectedType(e.currentTarget.value);
                            if(e.currentTarget.value !== "NEW_TYPE"){
                                setCustomType("");
                            }
                        }}
                    >
                        <option value = "">Select Type</option>
                        {types.map((type, index) => 
                            <option key = {index} value = {type}>
                                {type}
                            </option>
                        )}
                        <option value = "NEW_TYPE">+ New Type</option>
                    </select>
                </div>
                
                {selectedType === "NEW_TYPE" && (
                    <div className = "d-flex align-items-center mt-2">
                        <label htmlFor = "customType" className = "font-weight-bold mb-0">Type Name:</label>
                        <input
                            id = "customType"
                            type = "text"
                            className = "form-control flex-grow-1 ml-3"
                            value = {customType}
                            onChange = {e => setCustomType(e.currentTarget.value)}
                            placeholder = "e.g., Visa, Mastercard, Amex"
                        />
                    </div>
                )}
                
                <div className = "d-flex align-items-center mt-2">
                    <label htmlFor = "last4" className = "font-weight-bold mb-0">Last 4 Digits:</label>
                    <input
                        id = "last4"
                        type = "text"
                        className = "form-control flex-grow-1 ml-3"
                        value = {last4}
                        onChange = {e => {
                            const value = e.currentTarget.value.replace(/\D/g, '').slice(0, 4);
                            setLast4(value);
                        }}
                        placeholder = "1234"
                        maxLength = {4}
                    />
                </div>
            </div>
        </Modal>
    )
}
